window.dataLayer = window.dataLayer || [];
let _dataLayer = window.dataLayer;
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            let val = c.substring(name.length, c.length);
            // Strip leading/trailing double quotes some sources add around cookie values
            return val.replace(/^"+|"+$/g, "");
        }
    }
    return "";
}
function setCookie(cname, cvalue, exminutes, domain) {
    const d = new Date();
    d.setTime(d.getTime() + exminutes * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();

    let cookieString = cname + "=" + cvalue + ";" + expires + ";path=/;Secure";

    if (domain) {
        cookieString += ";domain=" + domain;
    }

    document.cookie = cookieString;
}
function fetch_query_param(paramName) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
}
function generateRandomTrackingId() {
    // Generate a random tracking ID, similar to consumerUI
    const now = new Date();
    const pad = n => n.toString().padStart(2, '0');
    const datetimeStr =
        now.getFullYear().toString() +
        pad(now.getMonth() + 1) +
        pad(now.getDate()) +
        pad(now.getHours()) +
        pad(now.getMinutes()) +
        pad(now.getSeconds());
    const randomNum = Math.floor(Math.random() * 1001); // 0 to 1000 inclusive
    const visit_cookie_id = datetimeStr + randomNum.toString();
    return visit_cookie_id;
}


// Constants for loan calculations
const INTEREST_MODIFIER = '0.927856444';
const MONTHLY_PAYABLE_MODIFIER = '0.321309407';

// Utility functions for hero form
function defaultToMinMax(value, min, max, options = {}) {
    const {
        isRounded = true,
        step = 10,
    } = options;

    if (value < min || (!value && min !== undefined)) {
        value = min;
    } else if (value > max) {
        value = max;
    }
    return isRounded ? Math.round(value / step) * step : value;
}

function decimal(val, decimalPlaces = 2) {
    if (typeof val !== 'number') {
        val = parseFloat(val);
    }

    if (isNaN(val)) {
        return NaN;
    }

    return val.toFixed(decimalPlaces);
}

function calculateAmount(loanAmount = 200, defaultValue = 6) {
    let interest_modifier = parseFloat(INTEREST_MODIFIER);
    let monthly_payable_modifier = parseFloat(MONTHLY_PAYABLE_MODIFIER);

    let loan_amount = parseInt(loanAmount);
    if (
        isNaN(loan_amount) ||
        isNaN(interest_modifier) ||
        isNaN(monthly_payable_modifier)
    ) {
        return;
    }

    let totalInterest;
    let monthly_payable;

    if (defaultValue === 6) {
        totalInterest = loan_amount * interest_modifier;
        monthly_payable = loan_amount * monthly_payable_modifier;
    }
    // For now, only supporting 6-month terms as per Lendingstream version
    // Additional term support can be added later with respective modifiers

    return { totalInterest, monthly_payable };
}

// V3 Slider handler - supports multiple forms (Lendingstream version)
function v3HandleSlider() {
    // Generic function to handle slider logic
    const initializeSlider = (formSelector) => {
        const form = document.querySelector(formSelector);
        if (!form) return;

        const rangeInput = form.querySelector('.hero-form-range');
        const textInput = form.querySelector('.hero-form-amount');
        const cta = form.querySelector('.v3-slider-submit');
        const table = form.querySelector('.table-holder');

        // Common component added in wordpress to access the routing of apply pages
        let pageUrl = '/application/apply';
        // Select the element with the 'data-pageurl' attribute
        const element = form.querySelector('[data-pageurl]');
        // Check if the element exists and has the 'data-pageurl' attribute
        if (element && element.hasAttribute('data-pageurl')) {
            const attrValue = element.getAttribute('data-pageurl').trim();
            if (attrValue) {
                pageUrl = attrValue; // Assign only if it's not empty
            }
        }
        if (pageUrl.endsWith('/')) {
            pageUrl = pageUrl.slice(0, -1); // Remove the last character (slash)
        }

        let tableAmountBorrowed, tableTotalInterest, tableMonthlyRepayable, tableLoanTerms;

        if (table) {
            tableLoanTerms = form.querySelector('.tableLoanTerms');
            tableAmountBorrowed = form.querySelector('.tableAmountBorrowed');
            tableTotalInterest = form.querySelector('.tableTotalInterest');
            tableMonthlyRepayable = form.querySelector('.tableMonthlyRepayable');
        }

        if (!rangeInput || !textInput) {
            return; // Exit if required elements are not found
        }

        let loanAmount = rangeInput.value;
        let defaultValue = 6;

        const updateTableValues = (value, defaultValue) => {
            if (table) {
                const result = calculateAmount(value, defaultValue);
                if (tableLoanTerms) {
                    tableLoanTerms.textContent = defaultValue;
                }
                if (tableAmountBorrowed) {
                    tableAmountBorrowed.textContent = decimal(value, 2);
                }
                if (tableTotalInterest) {
                    tableTotalInterest.textContent = decimal(result.totalInterest, 2);
                }
                if (tableMonthlyRepayable) {
                    tableMonthlyRepayable.textContent = decimal(result.monthly_payable, 2);
                }
            }
        };

        // Initialize table values
        updateTableValues(loanAmount, defaultValue);

        // Handlers
        const handleRangeChange = () => {
            loanAmount = rangeInput.value;
            textInput.value = loanAmount;
            updateTableValues(loanAmount, defaultValue);
        };

        const handleTextInputChange = () => {
            rangeInput.value = textInput.value;
        };

        const handleTextInputBlur = () => {
            let roundedValue = defaultToMinMax(
                textInput.value,
                parseInt(rangeInput.min),
                parseInt(rangeInput.max),
                { isRounded: true, step: 10 }
            );

            textInput.value = roundedValue;
            rangeInput.value = roundedValue;
            loanAmount = roundedValue;
            updateTableValues(roundedValue, defaultValue);
        };

        const handleApplyButtonClick = (e) => {
            e.preventDefault();
            const queryParams = {
                loan_amount: loanAmount,
            };

            // Add loan_term only if it's not the default value = 6
            if (defaultValue !== 6) {
                queryParams.loan_term = defaultValue;
            }

            const queryString = new URLSearchParams(queryParams).toString();
            const separator = pageUrl.includes('?') ? '&' : '/?';
            window.location.href = `${pageUrl}${separator}${queryString}`;
        };

        // Attach event listeners
        rangeInput.addEventListener('input', handleRangeChange);
        textInput.addEventListener('input', handleTextInputChange);
        textInput.addEventListener('blur', handleTextInputBlur);
        if (cta) cta.addEventListener('click', handleApplyButtonClick);
    };

    // Initialize sliders for both forms
    initializeSlider('.v3-order-slider-1');
    initializeSlider('.v3-order-slider-2');
}

// Legacy hero form handler for backward compatibility
function handleHeroForm() {
    // Step 1: Identify the element with id="hero-form"
    const heroForm = document.querySelector('#hero-form');
    if (heroForm) {
        // Step 2: Get form elements
        const rangeInput = heroForm.querySelector('#hero-form-range');
        const textInput = heroForm.querySelector('#hero-form-amount');
        const cta = heroForm.querySelector('#applyNow');

        // Step 2a: Get table elements
        const tableAmountBorrowed = heroForm.querySelector('#tableAmountBorrowed');
        const tableTotalInterest = heroForm.querySelector('#tableTotalInterest');
        const tableMonthlyRepayable = heroForm.querySelector('#tableMonthlyRepayable');

        if (!rangeInput || !textInput) {
            return; // Exit if required elements are not found
        }

        let loanAmount = rangeInput.value;
        const defaultTerm = 6;

        // Initialize table values on load
        if (tableAmountBorrowed && tableTotalInterest && tableMonthlyRepayable) {
            const rangeValue = rangeInput.value;
            tableAmountBorrowed.textContent = decimal(rangeValue, 2);
            const result = calculateAmount(rangeValue, defaultTerm);
            tableTotalInterest.textContent = decimal(result.totalInterest, 2);
            tableMonthlyRepayable.textContent = decimal(result.monthly_payable, 2);
        }

        // Step 3: Handle range input changes
        function handleRangeChange() {
            const rangeValue = rangeInput.value;
            textInput.value = rangeValue;
            loanAmount = rangeValue;

            if (tableAmountBorrowed && tableTotalInterest && tableMonthlyRepayable) {
                const result = calculateAmount(rangeValue, defaultTerm);
                tableAmountBorrowed.textContent = decimal(rangeValue, 2);
                tableTotalInterest.textContent = decimal(result.totalInterest, 2);
                tableMonthlyRepayable.textContent = decimal(result.monthly_payable, 2);
            }
        }

        // Step 4: Handle text input changes
        function handleTextInputChange() {
            const textValue = textInput.value;
            rangeInput.value = textValue;
        }

        // Step 5: Handle text input blur (validation)
        function handleTextInputBlur() {
            const textValue = textInput.value;
            const minValue = parseInt(rangeInput.min) || 50;
            const maxValue = parseInt(rangeInput.max) || 5000;

            const roundedValue = defaultToMinMax(textValue, minValue, maxValue, { isRounded: true, step: 10 });

            textInput.value = roundedValue;
            rangeInput.value = roundedValue;
            loanAmount = roundedValue;

            if (tableAmountBorrowed && tableTotalInterest && tableMonthlyRepayable) {
                tableAmountBorrowed.textContent = decimal(roundedValue, 2);
                const result = calculateAmount(roundedValue, defaultTerm);
                tableTotalInterest.textContent = decimal(result.totalInterest, 2);
                tableMonthlyRepayable.textContent = decimal(result.monthly_payable, 2);
            }
        }

        // Step 6: Handle apply button click
        function handleApplyButtonClick(e) {
            e.preventDefault();
            const queryParams = new URLSearchParams({ loan_amount: loanAmount });
            const applicationUrl = `/application/apply/?${queryParams.toString()}`;
            window.location.href = applicationUrl;
        }

        // Attach event listeners
        rangeInput.addEventListener('input', handleRangeChange);
        textInput.addEventListener('input', handleTextInputChange);
        textInput.addEventListener('blur', handleTextInputBlur);

        if (cta) {
            cta.addEventListener('click', handleApplyButtonClick);
        }
    }
}

function trackClickEvent(event) {
    var el = event.target;
    if (
        el && el.tagName && el.tagName.toLowerCase() === 'span' &&
        !el.getAttribute('data-notifyid')
    ) {
        return;
    }
    var eventName = el.getAttribute('data-track');

    while (!eventName && el.parentElement && el.tagName !== 'BODY') {
        el = el.parentElement;
        eventName = el.getAttribute('data-track');
    }

    if (!eventName) {
        eventName = event.target.textContent || document.title;
    }
    if (window.newrelic) {
        window.newrelic.addPageAction("click", { eventName })
    }
}

function updateNewRelicCustomVars(account_id, riskprofile_id) {
    if (window.newrelic) {
        const visit_cookie_id = getCookie("visit_cookie_id") || "";
        const query_params = window.location.search || "";
        const lsrc = getCookie("lsrc") || "";
        const lsrc_current = getCookie("lsrc_current") || ""; //TODO: Update this properly (it is not a cookie)
        // Set NewRelic custom vars
        window.newrelic.setCustomAttribute("custom/visit_cookie_id", visit_cookie_id);
        window.newrelic.setCustomAttribute("custom/lsrc", lsrc);
        window.newrelic.setCustomAttribute("custom/lsrc_current", lsrc_current);
        window.newrelic.setCustomAttribute("custom/account_id", account_id);
        window.newrelic.setCustomAttribute("custom/riskprofile_id", riskprofile_id);
        window.newrelic.setCustomAttribute("custom/query_params", query_params);
    }
}

// Function to handle accordion behavior
function handleAccordionBehavior() {
    // Handle click outside to close all accordions
    document.addEventListener('click', function (event) {
        // Get all accordion details elements
        const accordions = document.querySelectorAll('details');

        // Check if click is outside all accordions
        let clickedInsideAccordion = false;

        accordions.forEach(function (accordion) {
            if (accordion.contains(event.target)) {
                clickedInsideAccordion = true;
            }
        });

        // If click is outside all accordions, close them all
        if (!clickedInsideAccordion && accordions.length > 0) {
            accordions.forEach(function (accordion) {
                accordion.removeAttribute('open');
            });
        }
    });

    // Handle accordion summary clicks to ensure only one is open at a time
    document.addEventListener('click', function (event) {
        // Check if the clicked element is a summary inside a details element
        const summary = event.target.closest('summary');
        if (summary) {
            const parentDetails = summary.parentElement;
            if (parentDetails && parentDetails.tagName.toLowerCase() === 'details') {
                // Get all accordion details elements
                const allAccordions = document.querySelectorAll('details');
                const menu = document.getElementsByClassName('large-menu');
                let clikedMenu = false;
                Array.from(menu).forEach(function (menuItem) {
                    if (menuItem.contains(event.target)) {
                        clikedMenu = true;
                    }
                });
                // Close all other accordions except the one being clicked
                allAccordions.forEach(function (accordion) {
                    if (accordion !== parentDetails && clikedMenu != true) {
                        accordion.removeAttribute('open');
                    }
                });
            }
        }
    });
}

// Initialize hero form when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    // Existing DOMContentLoaded code...
    let persistent_sessionid = getCookie("visit_cookie_id") || "";
    if (!persistent_sessionid) {
        persistent_sessionid = generateRandomTrackingId();
        setCookie('visit_cookie_id', persistent_sessionid, 24 * 30 * 6);
    }
    // Generate and set leadsource cookies
    generateAndSetLeadsource();
    // Get lsat cookie and parse as JSON to extract account_id and riskprofile_id
    const lsat = getCookie("lsat") || "";
    let account_id = "";
    let riskprofile_id = "";

    if (lsat) {
        Array.from(document.querySelectorAll('[data-track="SI_Logout_Header"]')).forEach(
            function (element) {
                element.text = "Logout";
                element.href = "/consumer/logout/";
            }
        );
        try {
            const lsatData = JSON.parse(lsat);
            account_id = lsatData.account_id || "";
            riskprofile_id = lsatData.riskprofile_id || "";
        } catch (error) {
            // Values remain empty strings if parsing fails
        }
    }
    updateNewRelicCustomVars(account_id, riskprofile_id);

    // Initialize window.data if it doesn't exist
    window.data = window.data || {};
    window.data["uid"] = getCookie("visit_cookie_id");
    window.data["Leadsource"] = getCookie("lsrc");
    window.data["AccountID"] = account_id;
    _dataLayer.push(window.data);
    setTimeout(function () {
        if (typeof clarity !== 'undefined') {
            clarity("set", "sessionid", getCookie("visit_cookie_id") || "");
        }
    }, 1000);
    // Initialize slider forms
    v3HandleSlider(); // Initialize v3 sliders first
    handleHeroForm(); // Initialize legacy hero form for backward compatibility
    document.addEventListener('click', trackClickEvent);

    // Initialize accordion behavior handler
    handleAccordionBehavior();

    // Initialize A/B tests
    initializeABTests();

    // Initialize blog pagination
    initializeBlogPagination();
});

// Leadsource generation logic - JavaScript port from Python
class LeadSourceStringGenerator {
    static isFromAffiliateProCookies(product, metaData) {
        try {
            const affVars = this.getFilteredDict(
                lsrc_config.INPUT_ATTRS_AFFILIATES,
                metaData.params
            );

            if (Object.keys(affVars).length === lsrc_config.OUTPUT_ATTRS_AFFILIATES.length) {
                const lsrc = `${affVars.group_id}_${affVars.user_id}_LSAffiliate_utm`;
                return { isMatch: true, cookies: { lsrc } };
            }
            return { isMatch: false, cookies: {} };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    static isFromLsInternalChannel(product, metaData) {
        try {
            if (metaData.referer &&
                metaData.referer !== 'None' &&
                metaData.hostName &&
                metaData.referer.includes(metaData.hostName)) {
                const lsrc = lsrc_config.ls_internal_string;
                return { isMatch: true, cookies: { lsrc } };
            }
            return { isMatch: false, cookies: {} };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    static isFromNonWebsiteReferral(product, metaData) {
        try {
            if (metaData.referer &&
                metaData.referer !== 'None' &&
                metaData.hostName &&
                !metaData.referer.includes(metaData.hostName)) {
                const lsrc = lsrc_config.ls_organic_string;
                return { isMatch: true, cookies: { lsrc } };
            }
            return { isMatch: false, cookies: {} };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    static isFromNoReferralButDirect(product, metaData) {
        try {
            if (!metaData.referer || metaData.referer === 'None') {
                const lsrc = lsrc_config.ls_direct_string;
                return { isMatch: true, cookies: { lsrc } };
            }
            return { isMatch: false, cookies: {} };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    static isWithUtmParams(product, metaData) {
        try {
            const utmVars = this.getFilteredDict(
                lsrc_config.INPUT_ATTRS_UTM,
                metaData.params
            );

            if (Object.keys(utmVars).length > 0) {
                const lsrcParts = lsrc_config.OUTPUT_ATTRS_UTM
                    .map(attr => utmVars[attr] || 'None')
                    .filter(val => val !== 'None');

                if (lsrcParts.length > 0) {
                    const lsrc = lsrcParts.join('_') + '_utm';
                    return { isMatch: true, cookies: { lsrc } };
                }
            }
            return { isMatch: false, cookies: {} };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    static isFromFreeGoogleBrandedOrNonBranded(product, metaData) {
        try {
            if (!metaData.referer || metaData.referer === 'None') {
                return { isMatch: false, cookies: {} };
            }

            const url = new URL(metaData.referer);
            const host = url.hostname;
            const query = url.search;

            if (!query || !host.includes('google')) {
                return { isMatch: false, cookies: {} };
            }

            const queryParams = new URLSearchParams(query);
            const searchKey = (queryParams.get('q') || '').replace(/\+/g, ' ').toLowerCase();

            if (!searchKey) {
                return { isMatch: false, cookies: {} };
            }

            const searchStrings = lsrc_config.SEARCH_STRINGS.map(s => s.replace(/\+/g, ' ').toLowerCase());

            let lsrc;
            if (searchStrings.includes(searchKey)) {
                lsrc = `branded_leads$$${searchKey}`;
            } else {
                lsrc = `non_branded_leads$$${searchKey}`;
            }

            return { isMatch: true, cookies: { lsrc } };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    static isWithGahParams(product, metaData) {
        try {
            const gahVars = this.getFilteredDict(
                lsrc_config.INPUT_ATTRS_GAH,
                metaData.params
            );

            if (Object.keys(gahVars).length > 0) {
                const lsrcParts = lsrc_config.OUTPUT_ATTRS_GAH
                    .map(attr => gahVars[attr])
                    .filter(val => val);

                if (lsrcParts.length > 0) {
                    const lsrc = lsrcParts.join('_');
                    return { isMatch: true, cookies: { lsrc } };
                }
            }
            return { isMatch: false, cookies: {} };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    static getLpLsrc(product, metaData, lsrc, code) {
        try {
            const lpCode = code;
            const inclusionConfig = lsrc_config.ls_inclusion_config[lpCode] || [];
            const exclusionConfig = lsrc_config.ls_exclusion_config[lpCode] || [];

            // Use direct string for LSD if lsrc is empty
            const finalLsrc = (lpCode === "LSD" && !lsrc) ? lsrc_config.ls_direct_string : lsrc;
            const lpPriority = lsrc_config.ls_string_priority;

            const isMatch = this.checkInclusionExclusion(finalLsrc, inclusionConfig, exclusionConfig);

            if (isMatch || lpCode === 'LSD') {
                const extra = {
                    priority: lpPriority[lpCode],
                    code: lpCode
                };
                const lsrcDetail = Object.entries(extra).map(([k, v]) => `${k}=${v}`).join('|');
                return { isMatch: true, cookies: { lsrc: finalLsrc, lsrc_detail: lsrcDetail } };
            }
            return { isMatch: false, cookies: {} };
        } catch (error) {
            return { isMatch: false, cookies: {} };
        }
    }

    // Utility methods
    static getFilteredDict(reqArr, inpDict) {
        const respDict = {};
        for (const key of reqArr) {
            if (inpDict && inpDict[key]) {
                respDict[key] = decodeURIComponent(inpDict[key]);
            }
        }
        return respDict;
    }

    static lowerCaseMatch(string, arr) {
        if (!string || !arr) return false;
        const lowerString = string.toLowerCase();
        return arr.some(pattern => {
            try {
                const regex = new RegExp(pattern.toLowerCase());
                return regex.test(lowerString);
            } catch (e) {
                return lowerString.includes(pattern.toLowerCase());
            }
        });
    }

    static checkInclusionExclusion(string, inclusionConfig, exclusionConfig) {
        if (!string) return false;

        const matchesExclusion = this.lowerCaseMatch(string, exclusionConfig);
        const matchesInclusion = this.lowerCaseMatch(string, inclusionConfig);

        return !matchesExclusion && matchesInclusion;
    }
}

class LeadSource {
    constructor() {
        this.leadgenObj = LeadSourceStringGenerator;
    }

    static getLsFromCookie(cookiesDict, product) {

        // Handle drafty vs other products
        const lsrcName = (product === 'drafty' || product === 'drafty-loan') ? 'glsrc' : 'lsrc';

        const curLsrc = cookiesDict[lsrcName];
        const curLsrcInfo = cookiesDict['lsrc_detail'];
        const curLsrcHistory = cookiesDict['lsrc_history'];

        const lsrcInfo = this.strDictConv(curLsrcInfo);
        lsrcInfo.lsrc = curLsrc ? curLsrc.replace(/"/g, '') : curLsrc;
        lsrcInfo.lsrc_detail = curLsrcInfo ? curLsrcInfo.replace(/"/g, '') : curLsrcInfo;
        lsrcInfo.lsrc_history = curLsrcHistory;

        return lsrcInfo;
    }

    static strDictConv(string, itemSep = '|', valueSep = '=') {
        if (!string) return {};
        const cleanString = string.replace(/"/g, '');
        const result = {};

        cleanString.split(itemSep).forEach(item => {
            const [key, ...valueParts] = item.split(valueSep);
            if (key) {
                result[key] = valueParts.join(valueSep).replace(new RegExp(valueSep + '$'), '');
            }
        });

        return result;
    }

    getLsrc(product, metaData) {
        try {
            const metaDataCopy = { ...metaData };

            // Process hostname
            if (metaDataCopy.hostName && metaDataCopy.hostName.includes('.')) {
                const parts = metaDataCopy.hostName.split('.');
                if (parts.length > 1) {
                    metaDataCopy.hostName = parts.slice(1).join('.');
                }
            }

            let lsrcHistory = '';
            let lsrcCurrent = '';

            // Get existing lsrc from cookies
            const curCookieInfo = LeadSource.getLsFromCookie(metaDataCopy.cookiesDict, product);

            // Extract priority from cookie
            let curPriority = curCookieInfo.priority || '';
            curPriority = (curPriority && !isNaN(curPriority)) ? parseInt(curPriority) : '';

            // Get lead providers based on priority
            const lsPriorityKeys = Object.keys(lsrc_config.ls_func_priority);
            const leadProviders = lsPriorityKeys.map(code => [
                lsrc_config.ls_func_mapping[code],
                lsrc_config.ls_func_priority[code]
            ]).filter(([, priority]) => priority);

            // Sort by priority
            const lpToCheck = leadProviders.sort((a, b) => a[1] - b[1]);

            // Default cookies
            let isLsrc = false;
            let matchedResult = null;
            const defaultCookiesToSet = { lsrc: lsrc_config.ls_default_string };

            // Check each lead provider function
            for (const [funcName, priority] of lpToCheck) {
                const result = this.leadgenObj[this.getFunctionName(funcName)](product, metaDataCopy);
                if (result.isMatch) {
                    isLsrc = true;
                    matchedResult = result;
                    break;
                }
            }

            const lsrc = isLsrc ? matchedResult.cookies.lsrc : defaultCookiesToSet.lsrc;

            // Process lead provider codes
            const leadProviderCodes = Object.entries(lsrc_config.ls_string_priority)
                .filter(([, priority]) => priority)
                .sort((a, b) => a[1] - b[1]);

            for (const [code, priority] of leadProviderCodes) {
                const result = this.leadgenObj.getLpLsrc(product, metaDataCopy, lsrc, code);

                if (!lsrcCurrent) {
                    lsrcCurrent = result.cookies.lsrc || '';
                }

                if (window.newrelic) {
                    window.newrelic.setCustomAttribute("custom/lsrc_current", lsrcCurrent);
                }
                if (result.isMatch && (curPriority === '' || curPriority >= priority)) {
                    // Handle lsrc history
                    if (curCookieInfo.lsrc_history) {
                        if (curCookieInfo.lsrc_history.includes(result.cookies.lsrc)) {
                            lsrcHistory = curCookieInfo.lsrc_history;
                        } else {
                            const timestamp = new Date().toISOString().replace(' ', '_');
                            lsrcHistory = `${curCookieInfo.lsrc_history}|${result.cookies.lsrc}__${timestamp}`;
                        }
                    } else {
                        const timestamp = new Date().toISOString().replace(' ', '_');
                        lsrcHistory = `${result.cookies.lsrc}__${timestamp}`;
                    }
                    if (window.newrelic) {
                        window.newrelic.setCustomAttribute("custom/lsrc", result.cookies.lsrc);
                    }
                    // Return cookies to set
                    return [
                        {
                            name: "lsrc",
                            value: result.cookies.lsrc,
                            expiry: lsrc_config.lsrc_lifetime
                        },
                        {
                            name: "lsrc_detail",
                            value: result.cookies.lsrc_detail,
                            expiry: lsrc_config.lsrc_detail_lifetime
                        },
                        {
                            name: "lsrc_history",
                            value: lsrcHistory,
                            expiry: lsrc_config.lsrc_history_lifetime
                        },
                        {
                            name: "lsrc_current",
                            value: lsrcCurrent,
                            expiry: lsrc_config.lsrc_lifetime
                        }
                    ];
                }
            }

            // Handle case where no lsrc cookie exists
            if (!curCookieInfo.lsrc) {
                const extra = { priority: 8, code: 'DD' };
                lsrcCurrent = lsrc_config.ls_default_string;
                curCookieInfo.lsrc = lsrc_config.ls_default_string;
                curCookieInfo.lsrc_detail = Object.entries(extra).map(([k, v]) => `${k}=${v}`).join('|');

                const timestamp = new Date().toISOString().replace(' ', '_');
                curCookieInfo.lsrc_history = `${curCookieInfo.lsrc_history || ''}|${curCookieInfo.lsrc}__${timestamp}`;
            }

            if (!lsrcCurrent) {
                lsrcCurrent = lsrc_config.ls_default_string;
            }

            // Return default cookies
            return [
                {
                    name: "lsrc",
                    value: `"${curCookieInfo.lsrc}"`,
                    expiry: lsrc_config.lsrc_lifetime
                },
                {
                    name: "lsrc_detail",
                    value: curCookieInfo.lsrc_detail,
                    expiry: lsrc_config.lsrc_detail_lifetime
                },
                {
                    name: "lsrc_history",
                    value: curCookieInfo.lsrc_history,
                    expiry: lsrc_config.lsrc_history_lifetime
                },
                {
                    name: "lsrc_current",
                    value: lsrcCurrent,
                    expiry: lsrc_config.lsrc_lifetime
                }
            ];

        } catch (error) {
            return [];
        }
    }

    getFunctionName(pythonFuncName) {
        const mapping = {
            'is_with_gah_parms': 'isWithGahParams',
            'is_from_free_google_branded_or_non_branded': 'isFromFreeGoogleBrandedOrNonBranded',
            'is_with_utm_parms': 'isWithUtmParams',
            'is_from_ls_internal_channel': 'isFromLsInternalChannel',
            'is_from_affiliate_pro_cookies': 'isFromAffiliateProCookies',
            'is_from_non_website_referral': 'isFromNonWebsiteReferral',
            'is_from_no_referral_but_direct': 'isFromNoReferralButDirect'
        };
        return mapping[pythonFuncName] || pythonFuncName;
    }
}

// Function to generate leadsource and set cookies
function generateAndSetLeadsource() {
    try {
        const product = "LS"; // Hardcoded as requested

        // Prepare metadata object
        const metaData = {
            hostName: window.location.hostname,
            referer: document.referrer,
            params: getQueryParams(),
            cookiesDict: getAllCookies()
        };


        // Create LeadSource instance and generate lsrc
        const leadSource = new LeadSource();
        const cookiesToSet = leadSource.getLsrc(product, metaData);

        const sanitizeCookieValue = (val) => (val || "").replace(/^"+|"+$/g, "");

        const lsrcCookie = cookiesToSet.find(cookie => cookie.name === "lsrc");
        const currentLsrc = sanitizeCookieValue(getCookie("lsrc"));
        const lsrcCookieValue = sanitizeCookieValue(lsrcCookie ? lsrcCookie.value : "");

        const shouldSetAllCookies = !lsrcCookie || lsrcCookieValue !== currentLsrc;
        if (shouldSetAllCookies) {
            cookiesToSet.forEach(cookie => {
                setCookie(cookie.name, cookie.value, parseInt(cookie.expiry) * 24);
            });
        } else {
            const lsrcCurrentCookie = cookiesToSet.find(cookie => cookie.name === "lsrc_current");
            if (lsrcCurrentCookie) {
                setCookie(
                    lsrcCurrentCookie.name,
                    lsrcCurrentCookie.value,
                    parseInt(lsrcCurrentCookie.expiry) * 24
                );
            }
        }

        return cookiesToSet;
    } catch (error) {
        return [];
    }
}

// Helper function to get all query parameters
function getQueryParams() {
    const params = {};
    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams) {
        params[key] = value.replace(" ", "+"); // Replace spaces as plus to avoid processing issues and keep it uniform
    }
    return params;
}

// Helper function to get leadsource-related cookies as a dictionary
function getAllCookies() {
    const cookies = {};

    // Get specific leadsource cookies using the existing getCookie function
    cookies['lsrc'] = getCookie('lsrc');
    cookies['glsrc'] = getCookie('glsrc');
    cookies['lsrc_detail'] = getCookie('lsrc_detail');
    cookies['lsrc_history'] = getCookie('lsrc_history');

    return cookies;
}

/**
 * Hash Generator Utility for deterministic random number generation.
 *
 * This module mirrors the behavior of the hash-based generator used in
 * the backend Python implementation. It provides a stable hash function
 * that converts a combination of a global seed, experiment identifier,
 * and entity identifier into a uniformly distributed number in the 0-99 range.
 *
 * Uses HMAC-SHA256 to ensure:
 * - Deterministic: Same inputs always produce same output
 * - Uniform distribution: Hash values are evenly distributed across range
 * - Cryptographically secure: Cannot be easily predicted or manipulated
 */

class HashGenerator {
  /**
   * Initialize hash generator with global seed.
   *
   * @param {string} globalSeed - Global seed for hash generation. Should be consistent
   *                              across all instances to ensure same hash results.
   */
  constructor(globalSeed = "abtf_global_seed_2026") {
    this.globalSeed = globalSeed;
  }

  /**
   * Generate deterministic random number (0-99) using hash function.
   *
   * Uses rejection sampling to ensure uniform distribution across 0-99.
   * This eliminates modulo bias that would favor lower numbers.
   *
   * @param {string|number} experimentId - Unique identifier for the experiment
   * @param {string} entityId - Unique identifier for the entity (customer_id, account_id, etc.)
   * @returns {Promise<number>} Random number between 0-99 (inclusive)
   */
  async generateHashNumber(experimentId, entityId) {
    const inputString = `${this.globalSeed}:${experimentId}:${entityId}`;

    // Convert global seed and input string to Uint8Array
    const encoder = new TextEncoder();
    const keyData = encoder.encode(this.globalSeed);
    const messageData = encoder.encode(inputString);

    // Import the key for HMAC
    const key = await crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "HMAC", hash: "SHA-256" },
      false,
      ["sign"]
    );

    // Generate HMAC-SHA256
    const signature = await crypto.subtle.sign("HMAC", key, messageData);

    // Use rejection sampling for uniform distribution
    // Take first 4 bytes (32 bits) and use rejection sampling
    const hashArray = new Uint8Array(signature);

    // Use first 4 bytes to create a 32-bit unsigned integer
    // >>> 0 converts signed to unsigned integer (prevents negative numbers)
    const value = ((hashArray[0] << 24) | (hashArray[1] << 16) | (hashArray[2] << 8) | hashArray[3]) >>> 0;

    // Rejection sampling: find largest multiple of 100 that fits in 32-bit space
    // maxUsable = 4294967200 (floor(2^32 / 100) * 100)
    const maxUsable = 4294967200;

    if (value < maxUsable) {
      // Value is in acceptable range - no bias
      return value % 100;
    }

    // If value is in biased range, use next 4 bytes
    // This happens ~0.002% of the time, so acceptable for deterministic use
    const value2 = ((hashArray[4] << 24) | (hashArray[5] << 16) | (hashArray[6] << 8) | hashArray[7]) >>> 0;

    if (value2 < maxUsable) {
      return value2 % 100;
    }

    // Extremely rare case - use simple modulo as fallback
    // Statistical impact is negligible (<0.000004%)
    return value2 % 100;
  }
}

// Export for use in other modules
if (typeof module !== "undefined" && module.exports) {
  module.exports = HashGenerator;
}

/**
 * Initialize and process A/B tests on the page.
 *
 * Finds all elements with class "ab-wrapper" and determines which variant
 * to show based on a deterministic hash of the experiment name and visitor ID.
 *
 * Process:
 * 1. Find all AB test wrappers on page
 * 2. For each wrapper, get experiment name and key
 * 3. Generate hash number using experiment name + visit_cookie_id
 * 4. Based on hash number and percentage splits, show one variant and hide others
 * 5. Report to NewRelic which variant was shown
 */
async function initializeABTests() {
  // Find all AB test wrappers
  const abWrappers = document.querySelectorAll('.ab-wrapper');

  if (abWrappers.length === 0) {
    return;
  }

  // Initialize hash generator
  const hashGenerator = new HashGenerator();

  // Process each AB test wrapper
  for (const wrapper of abWrappers) {
    try {
      // Add loading state
      wrapper.classList.add('ab-test-loading');

      // Get experiment details
      const experimentName = wrapper.getAttribute('data-ab-experiment-name');
      const experimentKey = wrapper.getAttribute('data-ab-experiment-key');

      if (!experimentName) {
        console.warn('AB Test wrapper missing data-ab-experiment-name', wrapper);
        wrapper.classList.remove('ab-test-loading');
        continue;
      }

      // Get entity ID based on experiment key
      let entityId;
      if (experimentKey === 'persistent_sessionid') {
        entityId = getCookie('visit_cookie_id');
        if (!entityId) {
          console.warn('visit_cookie_id cookie not found for AB test', experimentName);
          wrapper.classList.remove('ab-test-loading');
          continue;
        }
      } else {
        console.warn(`Unsupported experiment key: ${experimentKey}. Only 'persistent_sessionid' is supported.`);
        wrapper.classList.remove('ab-test-loading');
        continue;
      }

      // Get all variants
      const variants = wrapper.querySelectorAll('.wp-block-create-block-custom-ab-test-variant');

      if (variants.length === 0) {
        console.warn('No variants found in AB test wrapper', experimentName);
        wrapper.classList.remove('ab-test-loading');
        continue;
      }

      // Build variant information array
      const variantInfo = Array.from(variants).map(variant => ({
        element: variant,
        name: variant.getAttribute('data-ab-variant-name'),
        percentage: parseInt(variant.getAttribute('data-ab-variant-percentage') || '0', 10)
      }));
      // Validate percentages sum to 100
      const totalPercentage = variantInfo.reduce((sum, v) => sum + v.percentage, 0);
      if (totalPercentage !== 100) {
        console.warn(`AB Test ${experimentName} percentages sum to ${totalPercentage}, expected 100`);

        // Track percentage mismatch to NewRelic
        if (window.newrelic) {
          window.newrelic.addPageAction('ab_test_warning', {
            eventName: experimentName,
            value: `percentage_sum_${totalPercentage}`,
            category: 'percentage_mismatch'
          });
        }
      }

      // Generate hash number (0-99)
      const hashNumber = await hashGenerator.generateHashNumber(experimentName, entityId);

      // Determine which variant to show based on hash number
      let selectedVariant = null;
      let cumulativePercentage = 0;

      for (const variant of variantInfo) {
        cumulativePercentage += variant.percentage;
        if (hashNumber < cumulativePercentage) {
          selectedVariant = variant;
          break;
        }
      }

      // Fallback to first variant if none selected (shouldn't happen if percentages sum to 100)
      if (!selectedVariant && variantInfo.length > 0) {
        selectedVariant = variantInfo[0];

        // Track fallback to NewRelic
        if (window.newrelic) {
          window.newrelic.addPageAction('ab_test_warning', {
            eventName: experimentName,
            value: selectedVariant.name,
            category: 'fallback_to_first_variant'
          });
        }
      }

      // Show selected variant, remove others from DOM
      variantInfo.forEach(variant => {
        if (variant === selectedVariant) {
          // Add class to make variant visible (overrides default hidden state)
          variant.element.classList.add('ab-test-active');
        } else {
          // Remove non-selected variants from DOM completely (better for SEO)
          variant.element.remove();
        }
      });

      // Update NewRelic with the selected variant
      if (window.newrelic && selectedVariant) {
        // Add page action for tracking individual impressions
        window.newrelic.addPageAction('ab_test_assignment', {
          eventName: experimentName,
          value: selectedVariant.name,
          category: entityId
        });
      }
      // Track to Clarity
      if (typeof clarity !== 'undefined' && selectedVariant) {
          clarity('set', `ab_test_${experimentName}`, selectedVariant.name);
      }

      // Remove loading state
      wrapper.classList.remove('ab-test-loading');
      wrapper.classList.add('ab-test-loaded');

    } catch (error) {
      console.error('Error processing AB test:', error);

      // Track error to NewRelic
      if (window.newrelic) {
        window.newrelic.addPageAction('ab_test_error', {
          eventName: experimentName || 'unknown',
          value: error.message || error.toString(),
          category: experimentKey || 'unknown'
        });
      }

      // Remove loading state even on error and show all variants as fallback
      wrapper.classList.remove('ab-test-loading');
      wrapper.classList.add('ab-test-error');
    }
  }
}

// Blog Cards Pagination
function initializeBlogPagination() {
  const container = document.querySelector('.blog-cards-container');
  const pagination = document.querySelector('.blog-pagination');

  if (!container || !pagination) {
    return; // No blog cards or pagination on this page
  }

  const prevBtn = pagination.querySelector('.blog-pagination-prev');
  const nextBtn = pagination.querySelector('.blog-pagination-next');
  const pageButtons = pagination.querySelectorAll('.blog-pagination-number');
  const allCards = container.querySelectorAll('.blog-card');

  let currentPage = 1;
  const totalPages = pageButtons.length;

  // Function to show cards for a specific page
  function showPage(pageNumber) {
    currentPage = pageNumber;

    // Hide all cards
    allCards.forEach(card => {
      card.style.display = 'none';
    });

    // Show cards for current page
    const cardsToShow = container.querySelectorAll(`.blog-card[data-page="${pageNumber}"]`);
    cardsToShow.forEach(card => {
      card.style.display = 'flex';
    });

    // Update pagination buttons
    pageButtons.forEach(btn => {
      btn.classList.remove('active');
      if (parseInt(btn.dataset.page) === pageNumber) {
        btn.classList.add('active');
      }
    });

    // Update prev/next buttons
    prevBtn.disabled = currentPage === 1;
    nextBtn.disabled = currentPage === totalPages;

    // Scroll to top of blog cards
    container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Event listeners for page number buttons
  pageButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const page = parseInt(btn.dataset.page);
      showPage(page);
    });
  });

  // Event listener for previous button
  prevBtn.addEventListener('click', () => {
    if (currentPage > 1) {
      showPage(currentPage - 1);
    }
  });

  // Event listener for next button
  nextBtn.addEventListener('click', () => {
    if (currentPage < totalPages) {
      showPage(currentPage + 1);
    }
  });

  // Show first page initially
  showPage(1);
}
